import LoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton'
import { styled } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

export type CompletePurchaseButtonProps = LoadingButtonProps

const StyledLoadingButton = styled(LoadingButton)`
  width: 210px;
  height: 45px;
  color: #ffffff;
  background-color: #005bd7;
  text-transform: none;
  font-size: 16px;
  line-height: 18px;
  border-radius: 2px;

  &:hover {
    background-color: #3682eb;
  }

  &:disabled,
  &.disabled {
    background-color: #535556;
    color: #a0a0a0;
  }
`

export const CompletePurchaseButton: React.FC<
  CompletePurchaseButtonProps
> = props => {
  const { t } = useTranslation()

  const { children } = props

  return (
    <StyledLoadingButton {...props}>
      {children || t('common.complete_purchase')}
    </StyledLoadingButton>
  )
}
